var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXSocial = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.588 8.976-.633-.888L1.921 1.04H4.09l4.066 5.688.632.888 5.283 7.392h-2.169L7.588 8.976ZM14.07 0l-5.17 5.88L4.761 0H0l6.251 8.896L0 16h1.409l5.466-6.208L11.238 16H16L9.517 6.776 15.48 0H14.07Z",
  fill: "currentColor"
})));
export default SvgXSocial;